import { ProductFlagService } from '../../../../shared/ProductFlag.service';
import { DARKLY_PRODUCT_FLAGS } from '../../../../shared/constants';

export class VidaliaProductService {
  private productFlagService: ProductFlagService;

  private vidaliaEnabled: boolean;

  constructor(private productFlags: Record<string, boolean>) {
    this.productFlagService = new ProductFlagService();

    // Check if Vidalia P&P is enabled for the app. If Vidalia is enabled for
    // the app then it is absolutely true that VIDALIA is enabled.
    this.vidaliaEnabled = this.isProductFlagEnabled(DARKLY_PRODUCT_FLAGS.VIDALIA);
  }

  isVidaliaEnabled(): boolean {
    return this.vidaliaEnabled;
  }

  isProductFlagEnabled(productFlagName: string): boolean {
    return !!this.productFlagService.isProductFlagEnabled(productFlagName, this.productFlags, {});
  }

  // This method will always return true IF Vidalia is not enabled for the app.
  // This is primarily because we don't want to block any users NOT using Vidalia
  // from accessing the their products.
  isProductRouteEnabled(darklyProductFlag: string): boolean {
    if (!this.vidaliaEnabled) return true;

    return this.isProductFlagEnabled(darklyProductFlag);
  }
}
